import {parsePerseusGraphType} from "./interactive-graph-widget";

export const parseInteractiveGraphUserInput = parsePerseusGraphType;
